import { render, staticRenderFns } from "./BiographyStar.vue?vue&type=template&id=fe9f444e&scoped=true"
var script = {}
import style0 from "./BiographyStar.vue?vue&type=style&index=0&id=fe9f444e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9f444e",
  null
  
)

export default component.exports